import { Box, Grid, Typography } from '@mui/material';

import { FORTA_BLACK, FORTA_BLUE, FORTA_ERROR } from '../../../../utils/colors';
import SessionGradingSwitch from './GradingSwitchWithLabel';
import { SessionEvalSchemaVersion } from '../constants';
import { ScoreFieldsV1, ScoreFieldsV2 } from './config';

import type { IClinicalQAReview } from '../../../../utils/types';
import type { ClinicalQAScoreField } from './config';

interface ScoreSectionProps {
  gradingVersion: SessionEvalSchemaVersion;
  reviewData: IClinicalQAReview;
  isOneColumn: boolean;
  isEditable: boolean;
  disabled?: boolean;
  allScoresValued: boolean | null;
  onUpdate: (data: IClinicalQAReview) => void;
}

function ScoreSection(props: ScoreSectionProps) {
  const {
    reviewData,
    isOneColumn,
    isEditable,
    allScoresValued,
    gradingVersion,
    disabled = false,
    onUpdate,
  } = props;

  const ScoreFields =
    gradingVersion === SessionEvalSchemaVersion.V2 ? ScoreFieldsV2 : ScoreFieldsV1;

  const handleUpdate = (key: ClinicalQAScoreField, value: boolean) => {
    onUpdate({
      ...reviewData,
      [key]: value,
    });
  };

  return (
    <Box>
      {isEditable && (
        <Typography color={allScoresValued || allScoresValued === null ? FORTA_BLACK : FORTA_ERROR}>
          All criteria must be evaluated
        </Typography>
      )}
      <Grid container>
        <Grid
          item
          xs={isOneColumn ? 12 : 6}
          mt={2}
          pr={isOneColumn ? 0 : 2}
          borderRight={isOneColumn ? 'none' : `1px solid ${FORTA_BLUE.light1}`}
        >
          {ScoreFields.slice(0, 5).map((item) => (
            <SessionGradingSwitch
              key={item.field}
              value={reviewData[item.field]}
              isEditable={isEditable}
              disabled={disabled}
              datatestId={item.dataTestId}
              label={item.shortLabel}
              onChange={(val) => handleUpdate(item.field, val)}
            />
          ))}
        </Grid>
        <Grid item xs={isOneColumn ? 12 : 6} mt={isOneColumn ? 0 : 2} pl={isOneColumn ? 0 : 2}>
          {ScoreFields.slice(5).map((item) => (
            <SessionGradingSwitch
              key={item.field}
              value={reviewData[item.field]}
              isEditable={isEditable}
              disabled={disabled}
              datatestId={item.dataTestId}
              label={item.shortLabel}
              onChange={(val) => handleUpdate(item.field, val)}
            />
          ))}
        </Grid>
      </Grid>
    </Box>
  );
}

export default ScoreSection;
